import LocalStorageService from '../services/local-storage-service'

export const MAX_LISTING_VIEW_COUNTS = 10

/**
 * Return top N listing IDs sorted by epoch timestamp (descending - most recent first).
 */
export const getTopListingIdsFromViewCounts = (viewCounts: Record<string, number>, limit: number): string[] => {
    return Object.entries(viewCounts)
        .sort(([, epochA], [, epochB]) => epochB - epochA)
        .slice(0, limit)
        .map(([listingId]) => listingId)
}

/**
 * Update the view timestamp for a specific listing ID in localStorage.
 * Stores current epoch timestamp and keeps only top 10 most recently viewed listings.
 * Returns the current timestamp.
 */
export const incrementListingViewCount = async (listingId: string): Promise<number> => {
    try {
        const allViewTimestamps =
            (await LocalStorageService.getItem<Record<string, number>>(LocalStorageService.LISTING_VIEW_COUNTS)) ?? {}

        const currentTimestamp = Date.now()
        allViewTimestamps[listingId] = currentTimestamp

        const sortedEntries = Object.entries(allViewTimestamps).sort(([, epochA], [, epochB]) => epochB - epochA)
        const top10Entries = sortedEntries.slice(0, MAX_LISTING_VIEW_COUNTS)
        const top10ViewTimestamps = Object.fromEntries(top10Entries)

        await LocalStorageService.storeItem(LocalStorageService.LISTING_VIEW_COUNTS, top10ViewTimestamps)
        return currentTimestamp
    } catch (error) {
        console.error(`Error updating view timestamp for listing "${listingId}":`, error)
        return 0
    }
}

/**
 * Get top N listing IDs from localStorage only (no cookie logic).
 */
export const getTopListingsByCombinedViewCount = async (limit = MAX_LISTING_VIEW_COUNTS): Promise<string[]> => {
    try {
        const localViewTimestamps =
            (await LocalStorageService.getItem<Record<string, number>>(LocalStorageService.LISTING_VIEW_COUNTS)) ?? {}

        return getTopListingIdsFromViewCounts(localViewTimestamps, limit)
    } catch (error) {
        console.error('Error retrieving top listings by view timestamp:', error)
        return []
    }
}
